export default <template><@field.Control @onlyAvailable={{false}} /></template>
